import React from 'react';
import ItemList from '../../../components/item-list/ItemList';

const LoadsTable = ({
  loads,
  selectedLoads,
  onSelectAll,
  onSelectLoad,
  onToggleExpand,
  onDeleteSelected,
  onEdit,
  onViewFiles,
  canSelect = true,
  canDelete = true,
  canEdit = true,
  canDuplicate = true,
  currentPage,
  onPageChange,
  totalItems,
  itemsPerPage,
  isServerPaginated = false,
  loading = false
}) => {
  const columns = [
    { key: 'orderId', label: 'Order Id' },
    { key: 'date', label: 'DATE' },
    { key: 'type', label: 'Type' },
    { key: 'status', label: 'Status' },
    { key: 'actions', label: 'Actions' }
  ];

  return (
    <ItemList
      items={loads}
      itemType="loads"
      selectedItems={selectedLoads}
      onSelectAll={onSelectAll}
      onSelectItem={onSelectLoad}
      onToggleExpand={onToggleExpand}
      onDeleteSelected={onDeleteSelected}
      onEdit={onEdit}
      onViewFiles={onViewFiles}
      canSelect={canSelect}
      canDelete={canDelete}
      canEdit={canEdit}
      canDuplicate={canDuplicate}
      currentPage={currentPage}
      onPageChange={onPageChange}
      columns={columns}
      totalItems={totalItems}
      itemsPerPage={itemsPerPage}
      isServerPaginated={isServerPaginated}
      loading={loading}
    />
  );
};

export default LoadsTable;














